export function isFundingHostRouteEnabled(manifest, route, surface, masterEnabled, adapterImplemented) {
    const policy = manifest.onramp.host_routes[route];
    return masterEnabled && adapterImplemented && policy.enabled && policy.surfaces.includes(surface);
}
/** Portfolio selection wins within the host's active or primary-only wallet scope. */
export function resolveManualTransferWallet(wallets, activeWalletId, portfolioWalletId = null, primaryOnly = false) {
    const active = wallets.filter((wallet) => wallet.archivedAt === null);
    const primary = active.find((wallet) => wallet.isPrimary) ?? active[0];
    const scoped = primaryOnly ? (primary ? [primary] : []) : active;
    const eligible = scoped.filter((wallet) => wallet.isAvailable);
    return (eligible.find((wallet) => wallet.id === portfolioWalletId) ??
        eligible.find((wallet) => wallet.id === activeWalletId) ??
        eligible[0] ??
        null);
}
